<template>
    <!--ibt去掉desc :desc="$t('verificationStatus.ibtVerification.confirmPoa.desc')" -->
  <IbtRegisterForm
    :title="$t('verificationStatus.ibtVerification.confirmPoa.title')"
    :nextButtonOnClick="nextButtonOnClick"
    :backButtonOnClick="backButtonOnClick"
  >
    <div class="flex flex-col items-stretch justify-start">
      <PoaInformationComponent
        ref="infoForm"
        radioLabel="verificationStatus.ibtVerification.confirmPoa.poaTypeLabel"
        radioTypeInfoText="verificationStatus.ibtVerification.confirmPoa.radioTypeInfoText"
        :disabled="isInfoDisabled"
        :isIBT="true"
      />
      <PoaUploadComponent
        ref="uploadForm"
        :uploadInfoText="$t('verificationStatus.ibtVerification.confirmPoa.uploadInfoText')"
        :pendingReason="pendingReason"
      />
    </div>
  </IbtRegisterForm>
</template>

<script>
import PoaInformationComponent from '@/components/register/registerForms/uploadForms/PoaInformation.vue';
import PoaUploadComponent from '@/components/register/registerForms/uploadForms/PoaUpload.vue';
import IbtRegisterForm from '@/components/register/registerForms/IbtRegisterForm.vue';
import ibtStore from '@/store/register/ibtVerification/ibtStore';
import ibtStep from '@/constants/register/ibtStep';
import auditStatus from '@/constants/auditStatus';
import fileType from '@/constants/fileType';
import auditType from '@/constants/register/auditType';
import { endAjaxLoading, startLoading } from '@/util/loading';
import { mapGetters, mapState } from 'vuex';
import { urlToFile } from '@/util/convertToFile';
import commonRepository from '@/repositories/commonRepository';
import registerRepository from '@/repositories/register/registerRepository';
import registerStep from '@/constants/register/registerStep';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

export default {
  name: 'ConfirmPoa',
  components: { PoaInformationComponent, PoaUploadComponent, IbtRegisterForm },
  computed: {
    isInfoDisabled() {
      return this.ibtPoaAuditStatus === auditStatus.pending;
    },
    isPrefillGeneralUpload() {
      // Only prefill when init
      return this.ibtPoaAuditStatus === auditStatus.init;
    },
    pendingReason() {
      return this.ibtPoaAuditStatus === auditStatus.pending
        ? ibtStore.state.poaCustomPendingReason?.length > 0
          ? ibtStore.state.poaCustomPendingReason
          : ibtStore.state.poaPendingReason?.length > 0
          ? ibtStore.state.poaPendingReason
          : ''
        : '';
    },
    poiRecordId() {
      return ibtStore.state.poiRecordId;
    },
    poaRecordId() {
      return ibtStore.state.poaRecordId;
    },
    // Pending record
    poaPendingRecord() {
      return ibtStore.state.poaPendingRecord;
    },
    idInfoForm() {
      return ibtStore.state.idInfoForm;
    },
    idUploadForm() {
      return ibtStore.state.idUploadForm;
    },
    prevExistingIdAdvancedFilePathList() {
      return ibtStore.state.prevExistingIdAdvancedFilePathList;
    },
    prevExistingPoaAdvancedFilePathList() {
      return ibtStore.state.prevExistingPoaAdvancedFilePathList;
    },
    ...mapState('register', ['currStep']),
    ...mapState('common', ['ibtPoiAuditStatus', 'ibtPoaAuditStatus']),
    ...mapGetters('common', ['isIbtPoiEditable'])
  },
  mounted() {
    this.init();
    sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_VIEW, {
      openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV3
    })
  },
  methods: {
    async init() {
      if (this.ibtPoaAuditStatus === auditStatus.pending) {
        const response = await ibtStore.dispatch('actionGetData');
        if (response instanceof Error) {
          this.$message({
            message: response.message,
            type: 'error'
          });
        }

        if (this.$refs.infoForm?.form) {
          this.$refs.infoForm.form = {
            ...this.$refs.infoForm.form,
            ...this.poaPendingRecord
          };
        }
      } else {
        const response = await registerRepository.getData(5);
        if (response instanceof Error) {
          this.$message({
            message: response.message,
            type: 'error'
          });
        } else {
          const { countryId, address, suburb, poaType, poaDocFilePathList } = response;

          const addressInformationForm = {
            ...(countryId && { countryId }),
            ...(address && { address }),
            ...(suburb && { suburb }),
            ...(poaType && { poaType })
          };

          if (this.$refs.infoForm?.form) {
            this.$refs.infoForm.form = {
              ...this.$refs.infoForm.form,
              ...addressInformationForm
            };
          }

          if (this.isPrefillGeneralUpload && this.$refs.uploadForm?.form && poaDocFilePathList?.length > 0) {
            const prefillFilePathList =
              poaDocFilePathList.length === 1 ? poaDocFilePathList.slice(-1) : poaDocFilePathList.slice(-2);

            this.$refs.uploadForm.form = {
              ...this.$refs.uploadForm.form,
              ...(prefillFilePathList?.[0] && { frontImage: await urlToFile(`/api${prefillFilePathList[0]}`) }),
              ...(prefillFilePathList?.[1] && { backImage: await urlToFile(`/api${prefillFilePathList[1]}`) })
            };
            this.$nextTick(() => this.$refs.uploadForm.clearValidate());
          }
        }
      }
    },
    backButtonOnClick() {
      if (this.isIbtPoiEditable) {
        ibtStore.dispatch('setActiveTab', ibtStep.confirmId);
      } else {
        ibtStore.dispatch('setActiveTab', ibtStep.financialInformation);
      }
    },
    async nextButtonOnClick() {
      const valids = await Promise.all([
        new Promise(resolve => this.$refs.infoForm?.validate(valid => resolve(valid))),
        new Promise(resolve => this.$refs.uploadForm?.validate(valid => resolve(valid)))
      ]);

      const isInfoFormValid = valids[0];
      const isUploadFormValid = valids[1];

      if (isInfoFormValid && isUploadFormValid) {
        if (!this.isIbtPoiEditable) {
          this.submitPoaForm();
        } else {
          this.submitIdPoaForm();
        }
      }
    },
    async submitPoaForm() {
      const infoForm = this.$refs.infoForm.form;
      const uploadForm = this.$refs.uploadForm.form;

      const { frontImage, backImage } = uploadForm;

      startLoading('ajax');

      const uploadImagesResponses = await Promise.all([
        frontImage !== null ? commonRepository.uploadFile(frontImage) : null,
        backImage !== null ? commonRepository.uploadFile(backImage) : null
      ]);

      const frontImageResponse = uploadImagesResponses?.[0] ?? null;
      const backImageResponse = uploadImagesResponses?.[1] ?? null;

      if (frontImageResponse instanceof Error) {
        this.$message({
          message: frontImageResponse.message,
          type: 'error'
        });
      } else if (backImageResponse instanceof Error) {
        this.$message({
          message: backImageResponse.message,
          type: 'error'
        });
      } else {
        const updateInfoResponse = this.isInfoDisabled ? null : await registerRepository.updateUserIdAddress(infoForm);
        if (updateInfoResponse instanceof Error) {
          this.$message({
            message: updateInfoResponse.message,
            type: 'error'
          });
        } else {
          const verificationResponse = await registerRepository.sendVerification({
            filePathList: [
              ...(frontImageResponse !== null ? [frontImageResponse] : []),
              ...(backImageResponse !== null ? [backImageResponse] : [])
            ],
            fileType: fileType.poa,
            auditType: auditType.ibt,
            fileId: this.poaRecordId,
            isPending: this.ibtPoaAuditStatus === auditStatus.pending,
            prevExistingFilePathList: this.prevExistingPoaAdvancedFilePathList
          });

          if (verificationResponse instanceof Error) {
            this.$message({
              message: verificationResponse.message,
              type: 'error'
            });
          } else {
            this.$store.commit('common/setIbtPoaAuditStatus', auditStatus.submitted);
            ibtStore.dispatch('setStep', ibtStep.ibtStatus);
          }
        }
      }

      endAjaxLoading();
    },
    async submitIdPoaForm() {
      const { frontImage: idFrontImage, backImage: idBackImage } = this.idUploadForm;
      const { frontImage: poaFrontImage, backImage: poaBackImage } = this.$refs?.uploadForm?.form;

      startLoading('ajax');

      const uploadImagesResponses = await Promise.all([
        idFrontImage !== null ? commonRepository.uploadFile(idFrontImage) : null,
        idBackImage !== null ? commonRepository.uploadFile(idBackImage) : null,
        poaFrontImage !== null ? commonRepository.uploadFile(poaFrontImage) : null,
        poaBackImage !== null ? commonRepository.uploadFile(poaBackImage) : null
      ]);
      const idFrontImageResponse = uploadImagesResponses?.[0] ?? null;
      const idBackImageResponse = uploadImagesResponses?.[1] ?? null;
      const poaFrontImageResponse = uploadImagesResponses?.[2] ?? null;
      const poaBackImageResponse = uploadImagesResponses?.[3] ?? null;

      if (idFrontImageResponse instanceof Error) {
        this.$message({
          message: idFrontImageResponse.message,
          type: 'error'
        });
      } else if (idBackImageResponse instanceof Error) {
        this.$message({
          message: idBackImageResponse.message,
          type: 'error'
        });
      } else if (poaFrontImageResponse instanceof Error) {
        this.$message({
          message: poaFrontImageResponse.message,
          type: 'error'
        });
      } else if (poaBackImageResponse instanceof Error) {
        this.$message({
          message: poaBackImageResponse.message,
          type: 'error'
        });
      } else {
        const updateInfoResponse =
          this.idInfoForm === null && this.isInfoDisabled
            ? null
            : await registerRepository.updateUserIdAddress({
                ...this.idInfoForm,
                ...(!this.isInfoDisabled && this.$refs?.infoForm?.form)
              });
        if (updateInfoResponse instanceof Error) {
          this.$message({
            message: updateInfoResponse.message,
            type: 'error'
          });
        } else {
          const verificationResponses = await Promise.all([
            registerRepository.sendVerification({
              filePathList: [
                ...(idFrontImageResponse !== null ? [idFrontImageResponse] : []),
                ...(idBackImageResponse !== null ? [idBackImageResponse] : [])
              ],
              fileType: fileType.poi,
              auditType: auditType.ibt,
              fileId: this.poiRecordId,
              isPending: this.ibtPoiAuditStatus === auditStatus.pending,
              prevExistingFilePathList: this.prevExistingIdAdvancedFilePathList
            }),
            registerRepository.sendVerification({
              filePathList: [
                ...(poaFrontImageResponse !== null ? [poaFrontImageResponse] : []),
                ...(poaBackImageResponse !== null ? [poaBackImageResponse] : [])
              ],
              fileType: fileType.poa,
              auditType: auditType.ibt,
              fileId: this.poaRecordId,
              isPending: this.ibtPoaAuditStatus === auditStatus.pending,
              prevExistingFilePathList: this.prevExistingPoaAdvancedFilePathList
            })
          ]);

          const idVerificationResponse = verificationResponses?.[0] ?? null;
          const poaVerificationResponse = verificationResponses?.[1] ?? null;

          if (idVerificationResponse instanceof Error) {
            this.$message({
              message: idVerificationResponse.message,
              type: 'error'
            });
          } else if (poaVerificationResponse instanceof Error) {
            this.$message({
              message: poaVerificationResponse.message,
              type: 'error'
            });
          } else {
            this.$store.commit('common/setIbtPoiAuditStatus', auditStatus.submitted);
            this.$store.commit('common/setIbtPoaAuditStatus', auditStatus.submitted);
            ibtStore.dispatch('setStep', ibtStep.ibtStatus);
            // Update registerStep
            if (this.currStep < registerStep.poaSuccess) {
              await this.$store.dispatch('register/setStep', registerStep.poaSuccess);
            }
          }
        }
      }

      endAjaxLoading();
    }
  }
};
</script>
